import chat from './chat.json';

export default { ...chat };
